import * as React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

import Backbone from 'backbone';

import { TeacherRouter, useSocrativeRouter } from '../RouterContext';

const CurrentRouteContext = createContext<string | null>(null);

function useTrackSelectedRoute(teacherRouter: TeacherRouter) {
  const fragment = Backbone.history.getFragment();

  const [route, setRoute] = useState(fragment);

  useEffect(() => {
    const handleRouteChange = () => {
      const fragment = Backbone.history.getFragment();
      setRoute(fragment);
    };

    if (!teacherRouter) return;

    // Listen for all route changes
    teacherRouter.on('all', handleRouteChange);

    // Cleanup function that properly removes the event listener
    return () => {
      if (!teacherRouter) return;
      teacherRouter.off('all', handleRouteChange);
    };
  }, [teacherRouter]);

  return { route };
}

export function CurrentRouteProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const teacherRouter = useSocrativeRouter();
  const { route } = useTrackSelectedRoute(teacherRouter);
  return (
    <CurrentRouteContext.Provider value={route}>
      {children}
    </CurrentRouteContext.Provider>
  );
}

export function useCurrentRoute() {
  const route = useContext(CurrentRouteContext);
  if (!route) {
    throw new Error('CurrentRouteContext not found');
  }
  return route;
}
